export default [
  { year: '2001', img: '2001.png' },
  { year: '2002', img: '2002.png' },
  { year: '2017', img: '2017.png' },
  { year: '2023', img: '2023.png' },
  { year: '2024', img: '2024.png' },
  // 如有更多年份，按实际补全
]; 